import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

const RedeemPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  return <Navigate to={code ? `/pricing?code=${encodeURIComponent(code)}` : '/pricing'} replace />;
};

export default RedeemPage;
